"use strict";

var _type = require("../_utils/type");
;
;
;
var roleTypes = (0, _type.tuple)('self');
var statusTypes = (0, _type.tuple)('loading');